export default __webpack_public_path__ + "static/media/interstellarBackground.25505a0a.jpg";